import { useState, useRef, useEffect } from "react";
import { categories } from "@/mocks/categories";

export default function Hero() {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(e: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setDropdownOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <section className="relative min-h-screen flex items-center pt-16">
      <div className="absolute inset-0 overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20fashion%20product%20photography%20flat%20lay%20composition%20with%20diverse%20sneakers%20hoodies%20caps%20bags%20and%20accessories%20arranged%20in%20elegant%20circular%20pattern%20on%20warm%20cream%20surface%20soft%20diffused%20natural%20lighting%20editorial%20quality%20minimal%20aesthetic%20neutral%20beige%20and%20sand%20tones%20gentle%20gradients%20no%20harsh%20shadows%20clean%20sophisticated%20style&width=1600&height=900&seq=hero-v2-main-bg&orientation=landscape"
          alt="CSSBuy Spreadsheet fashion products"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/70 via-background-50/30 to-background-50/70"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center lg:items-start gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left pt-8 lg:pt-0">
            <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold text-foreground-900 leading-[1.05] tracking-tight">
              Melhor CSSBuy<br />
              Spreadsheet 2026
            </h1>
            <p className="mt-5 text-foreground-600 text-base md:text-lg max-w-xl mx-auto lg:mx-0 leading-relaxed">
              A maior coleção de CSSBuy Spreadsheet, links, Yupoo e guias de compra.
            </p>

            <div className="flex flex-col sm:flex-row items-center gap-4 mt-8 justify-center lg:justify-start">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="px-8 py-3.5 rounded-full bg-foreground-900 text-background-50 text-sm md:text-base font-semibold hover:bg-foreground-800 transition-all whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
              >
                Explorar Spreadsheet
                <i className="ri-arrow-right-up-line"></i>
              </a>

              <div className="relative" ref={dropdownRef}>
                <button
                  onClick={() => setDropdownOpen(!dropdownOpen)}
                  className="px-8 py-3.5 rounded-full border-2 border-foreground-900 text-foreground-900 text-sm md:text-base font-semibold hover:bg-foreground-900 hover:text-background-50 transition-all whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
                >
                  Categorias
                  {dropdownOpen ? (
                  <i className="ri-arrow-up-s-line transition-transform"></i>
                ) : (
                  <i className="ri-arrow-down-s-line transition-transform"></i>
                )}
                </button>

                {dropdownOpen && (
                  <div className="absolute top-full mt-2 left-0 sm:left-1/2 sm:-translate-x-1/2 bg-background-50 border border-background-200 rounded-xl shadow-lg py-2 w-56 z-50 max-h-80 overflow-y-auto">
                    {categories.map((cat) => (
                      <a
                        key={cat.name}
                        href={cat.url}
                        target="_blank"
                        rel="noopener nofollow"
                        className="block px-4 py-2.5 text-sm text-foreground-700 hover:bg-background-100 hover:text-foreground-900 transition-colors whitespace-nowrap cursor-pointer"
                      >
                        {cat.name}
                      </a>
                    ))}
                  </div>
                )}
              </div>
            </div>

            <div className="flex flex-wrap items-center gap-6 mt-8 justify-center lg:justify-start">
              {["Atualizado diariamente", "Links organizados", "Guias completos", "Suporte PT-BR"].map((item) => (
                <span key={item} className="inline-flex items-center gap-1.5 text-xs text-foreground-500 whitespace-nowrap">
                  <i className="ri-check-line text-primary-500 text-sm"></i>
                  {item}
                </span>
              ))}
            </div>

            <p className="mt-6 text-xs text-foreground-400">Última atualização: 2026</p>
          </div>

          <div className="flex-1 w-full max-w-lg">
            <div className="relative rounded-2xl overflow-hidden h-[320px] md:h-[400px]">
              <img
                src="https://readdy.ai/api/search-image?query=Luxury%20designer%20sneakers%20and%20premium%20fashion%20accessories%20elegantly%20displayed%20on%20minimalist%20warm%20cream%20surface%20soft%20natural%20side%20lighting%20casting%20gentle%20shadows%20editorial%20product%20photography%20with%20subtle%20grain%20texture%20clean%20refined%20composition%20neutral%20beige%20sand%20and%20ivory%20tones%20sophisticated%20aesthetic&width=800&height=600&seq=hero-v2-side-showcase&orientation=landscape"
                alt="CSSBuy products showcase"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-50/20 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}